module.exports = __webpack_public_path__ + "img/journal_note_add.256a8c08.svg";